<template>
  <div class="is-vip">
    <el-dialog
      v-if="visible"
      width="380px"
      :show-close="false"
      :visible.sync="visible"
      :before-close="(_) => $emit('visible', false)"
    >
      <div class="content">
        <img class="icon" src="@/assets/icon/info.png" alt="" />
        <div class="info">您当前身份处于非VIP普通用户 请开通VIP进行观看</div>
        <div
          class="open"
          @click="
            (_) => {
              $router.push('/vip');
              $emit('visible', false);
            }
          "
        >
          立即开通
        </div>
        <div class="close" @click.stop="$emit('visible', false)">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "IsVip",
  props: ["visible"],
  model: {
    prop: "visible",
    event: "visible",
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.is-vip {
  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
}
.content {
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  user-select: none;
  .icon {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }
  .info {
    width: 220px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .open {
    width: 160px;
    height: 45px;
    background: #ebd793;
    border-radius: 10px;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #553d0e;
  }
  .close {
    font-size: 16px;
    font-weight: 400;
    color: #909090;
  }
}
</style>
